/* tslint:disable */
/* eslint-disable */
/**
 * User service API
 * Service for user management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartnerConfirmRequest
 */
export interface PartnerConfirmRequest {
    /**
     * Email confirmation code
     * @type {string}
     * @memberof PartnerConfirmRequest
     */
    code: string;
    /**
     * User's email.
     * @type {string}
     * @memberof PartnerConfirmRequest
     */
    email?: string;
}

/**
 * Check if a given object implements the PartnerConfirmRequest interface.
 */
export function instanceOfPartnerConfirmRequest(value: object): boolean {
    if (!('code' in value)) return false;
    return true;
}

export function PartnerConfirmRequestFromJSON(json: any): PartnerConfirmRequest {
    return PartnerConfirmRequestFromJSONTyped(json, false);
}

export function PartnerConfirmRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerConfirmRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function PartnerConfirmRequestToJSON(value?: PartnerConfirmRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'code': value['code'],
        'email': value['email'],
    };
}

